import SoundUtils from './SoundUtils';
import MobileAudioFix from './MobileAudioFix';

import {hasAnyWebAudioSupport, AudioContext} from '.';

const singleGain = 0.5;
const reverseGain = 0.2;

const assetPaths = {
  heroSuccess: 'assets/audio/hero-success.mp3',
  cubeUp: 'assets/audio/cube-up.mp3',
  cubeDown: 'assets/audio/cube-down.mp3',
  cubeOver: 'assets/audio/cube-over.mp3',
  cubeSort: 'assets/audio/cube-sort.mp3',
  cubeCollide: 'assets/audio/cube-collide.mp3',
  interactionHover: 'assets/audio/interaction-hover.mp3',
  interactionActive: 'assets/audio/interaction-active.mp3',
  animationUp1: 'assets/audio/animation-up-1.mp3',
  animationUp2: 'assets/audio/animation-up-2.mp3',
  animationUp3: 'assets/audio/animation-up-3.mp3',
  animationDown1: 'assets/audio/animation-down-1.mp3',
  animationDown2: 'assets/audio/animation-down-2.mp3',
  animationDown3: 'assets/audio/animation-down-3.mp3',
};

export default class Single {
  static singleKeys = Object.keys(assetPaths);

  constructor() {
    if (!hasAnyWebAudioSupport) {
      this.play = () => {
        return null;
      };

      // eslint-disable-next-line no-constructor-return
      return null;
    }

    this.context = new AudioContext();
    this.gainNode = this.context.createGain();
    this.source = null;
    this.sounds = {};

    Single.singleKeys.forEach((key) => {
      SoundUtils.fetchAudioBuffer(assetPaths[key], this.context)
        .then((response) => {
          this.sounds[key] = response;
          return this.sounds[key];
        })
        .catch(() => {
          this.sounds[key] = null;
        });
    });

    this.mobileAudio = new MobileAudioFix(this.context);
    this.mobileAudio.init();
  }

  play(key, reverse = false) {
    if (!Single.singleKeys.includes(key)) {
      return Error(`The requested sound is not available: ${key}`);
    }

    return this._startSource(this.sounds[key], reverse);
  }

  _startSource(sound, reverse) {
    if (!sound) {
      return;
    }

    this.source = this.context.createBufferSource();
    this.source.buffer = reverse ? SoundUtils.reverseBuffer(sound, this.context) : sound;

    this._patchSourceMethods();
    this._setGain(reverse, this.source.buffer.duration);

    this.source.connect(this.gainNode);
    this.gainNode.connect(this.context.destination);

    this.source.start();
  }

  _setGain(reverse, duration) {
    this.gainNode.gain.setValueAtTime(singleGain, this.context.currentTime);

    if (reverse) {
      this.gainNode.gain.exponentialRampToValueAtTime(
        reverseGain,
        this.context.currentTime + duration,
      );
    }
  }

  _patchSourceMethods() {
    this.source.start = SoundUtils.methodPatch.start(this.source);
  }
}
